var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.255,
    height: 35.233,
    viewBox: "0 0 34.255 35.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.a{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}.b{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(18.761)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 15.494,
    height: 10.517
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 1.5,
    y: 1.5,
    width: 12.494,
    height: 7.517
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 24.716)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 15.494,
    height: 10.517
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 1.5,
    y: 1.5,
    width: 12.494,
    height: 7.517
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 15.494,
    height: 21.033
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 1.5,
    y: 1.5,
    width: 12.494,
    height: 18.033
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(18.761 14.199)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 15.494,
    height: 21.033
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 1.5,
    y: 1.5,
    width: 12.494,
    height: 18.033
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.3fae4ec9e5d37cd3680a696e352e21ff.svg";
export { ForwardRef as ReactComponent };